import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { Container, Card, Spinner } from "react-bootstrap";
import { RiArrowRightSLine, RiArrowLeftSLine } from "react-icons/ri";
import { FaRegCopy } from "react-icons/fa";
import { fetchWithAuth, logoutUser } from "./authApi";

const MyCanvas = React.memo(() => {
  const canvasRef = useRef(null);
  const setCanvasRef = (canvas) => {
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.strokeStyle = "red";
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(200, 100);
      ctx.stroke();
    }
  };

  return <canvas ref={setCanvasRef} id="myCanvas" />;
});
export default function WingoChart({
  results,
  setResults,
  colorList,
  setColorList,
}) {
  const [showaccordian, setShowaccordian] = useState(null);
  const [statsPages, setstatsPages] = useState(null);
  const user_id = localStorage.getItem("user_id");
  const isLoading = useRef(false);
  const [loading, setLoading] = useState(false);
  const category_slug = localStorage.getItem("category_slug");
  const subcategory_slug = localStorage.getItem("sub_category_slug");
  const [totalPages, setTotalPages] = useState("");
  const intervalM = localStorage.getItem("selectedInterval");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchResults = async () => {
    if (!intervalM) {
      console.error("intervalM is not set");
      return;
    }

    try {
      // isLoading.current = true;
      // setLoading(true);
      const url = `${process.env.REACT_APP_API_URL}one-min-result`;

      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          gametype: intervalM,
          page: currentPage,
          perpage: itemsPerPage,
        },
      };

      const response = await axios(config);
      const responseData = response.data.data;
      console.warn("responseData", responseData);
      setTotalPages(response.data.totalPages);

      if (responseData) {
        setResults(responseData);
      } else {
        console.warn("No data returned from API");
        setResults([]);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    } finally {
      // isLoading.current = false;
      // setLoading(false);
    }
  };
  const fetchResultsStats = async () => {
    if (!intervalM) {
      console.error("intervalM is not set");
      return;
    }

    try {
      // const url = `http://localhost:9001/api/users/last-100Results-Stats`;
      const url = `${process.env.REACT_APP_API_URL}last-100Results-Stats`;
      const config = {
        method: "POST",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          gametype: intervalM,
        },
      };

      const response = await axios(config);
      const responseData = response.data.stats;

      setstatsPages(response.data.stats);

      if (responseData) {
        setstatsPages(responseData);
      } else {
        console.warn("No data returned from API");
        setstatsPages([]);
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    } finally {
      // isLoading.current = false;
      // setLoading(false);
    }
  };

  const fetchcolorlist = async () => {
    if (!intervalM) {
      console.error("intervalM is not set");
      return;
    }
    try {
      isLoading.current = true;
      const response = await fetchWithAuth(
        `${process.env.REACT_APP_API_URL}color-bet-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            category_slug: category_slug,
            subcategory_slug: subcategory_slug,
            type: intervalM,
          }),
        },
      );

      let responseData1 = response.data.data;
      console.warn("responseData1", responseData1);

      if (responseData1 && responseData1.length > 0) {
        const resultDataShow = responseData1[0].result;
      }

      setColorList(responseData1);
      isLoading.current = false;
      setLoading(false);
    } catch (error) {
      isLoading.current = false;
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (category_slug && subcategory_slug && intervalM && !isLoading.current) {
      fetchcolorlist();
    }
    if (intervalM) {
      setResults([]);
      fetchResultsStats();
      fetchResults();
    }
  }, [category_slug, subcategory_slug, currentPage, intervalM]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    fetchResults();
  }, [colorList]);

  const [copied, setCopied] = useState(false);

  const handleCopy = (orderid) => {
    navigator.clipboard.writeText(orderid).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };

  const [lines, setLines] = useState([]); // Store lines for drawing
  const activeRefs = useRef([]); // Store refs for active number elements

  const chartTableRef = useRef(null);
  useEffect(() => {
    const updateLines = () => {
      const activePositions = [];
      const chartTableRect = chartTableRef.current?.getBoundingClientRect();

      if (!chartTableRect) return;

      results.forEach((item, index) => {
        const activeElement =
          activeRefs.current[index]?.querySelector(".active");
        if (activeElement) {
          const rect = activeElement.getBoundingClientRect();
          activePositions.push({
            x: rect.left + rect.width / 2 - chartTableRect.left,
            y: rect.top + rect.height / 2 - chartTableRect.top,
          });
        }
      });

      setLines(activePositions);
    };

    updateLines();
    window.addEventListener("resize", updateLines);
    return () => window.removeEventListener("resize", updateLines);
  }, [results]);

  return (
    <section className="wingochart">
      <Container>
        <div className="wingo padding_all">
          <div className="history mt-2">
            <Tabs>
              <TabList>
                <Tab>Game History</Tab>
                <Tab>Chart</Tab>
                <Tab>My History</Tab>
              </TabList>

              <TabPanel>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <>
                    <table className="table-auto table table-striped history_table">
                      <thead>
                        <tr>
                          <th className="">Period</th>
                          <th className="">Number</th>
                          <th className="">Big Small</th>
                          <th className="">Color</th>
                        </tr>
                      </thead>
                      <tbody>
                        {results &&
                          results.map((item) => (
                            <tr key={item.periodid}>
                              <td>{item.periodid || "N/A"}</td>
                              {/* <td>{item.periodidshow || "N/A"}</td> */}
                              <td>
                                <span
                                  className="gradient-text"
                                  style={{
                                    fontSize: "22px",
                                    fontWeight: "bold",
                                    color:
                                      item.color &&
                                      (item.color === "green violet" ||
                                        item.color === "red violet")
                                        ? "transparent" // Makes the text itself transparent so the gradient is visible
                                        : item.color &&
                                            typeof item.color === "string"
                                          ? item.color.split(" ")[0]
                                          : "inherit",
                                    backgroundImage:
                                      item.color === "green violet"
                                        ? "linear-gradient(180deg, #40ad72 51.48%, #b659fe 51.49%)"
                                        : item.color === "red violet"
                                          ? "linear-gradient(180deg, #ff0000 51.48%, #b659fe 51.49%)"
                                          : "none",
                                    WebkitBackgroundClip:
                                      item.color &&
                                      (item.color === "green violet" ||
                                        item.color === "red violet")
                                        ? "text"
                                        : "initial",
                                    backgroundClip:
                                      item.color &&
                                      (item.color === "green violet" ||
                                        item.color === "red violet")
                                        ? "text"
                                        : "initial",
                                  }}
                                >
                                  {typeof item.number === "number"
                                    ? item.number
                                    : "N/A"}
                                </span>
                              </td>
                              <td>
                                {item.number >= 5 && item.number <= 9
                                  ? "big"
                                  : "small"}
                              </td>
                              <td>
                                <div className="d-flex align-items-center justify-content-evenly">
                                  {item.color &&
                                  typeof item.color === "string" ? (
                                    item.color.includes(" ") ? (
                                      item.color
                                        .split(" ")
                                        .map((color, index) => (
                                          <span
                                            key={index}
                                            className="w-4 h-4 rounded-full"
                                            style={{ backgroundColor: color }}
                                          ></span>
                                        ))
                                    ) : (
                                      <span
                                        className="w-4 h-4 rounded-full"
                                        style={{ backgroundColor: item.color }}
                                      ></span>
                                    )
                                  ) : (
                                    <span
                                      className="w-4 h-4 rounded-full d-inline-block"
                                      style={{
                                        backgroundColor: item.color || "NA",
                                      }}
                                    ></span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    {/* Pagination controls */}
                    <div className="pagination-controls">
                      <nav>
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              onClick={() => paginate(currentPage - 1)}
                              className="page-link"
                              disabled={currentPage === 1}
                            >
                              <RiArrowLeftSLine />
                            </button>
                          </li>
                          <li className="page-item">
                            <span className="page-info">
                              {currentPage} of {totalPages}
                            </span>
                          </li>
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              onClick={() => paginate(currentPage + 1)}
                              className="page-link"
                              disabled={currentPage === totalPages}
                            >
                              <RiArrowRightSLine />
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </>
                )}
              </TabPanel>

              <TabPanel>
                <div>
                  <table className="table-auto table table-striped history_table">
                    <thead>
                      <tr>
                        <th className="">Period</th>
                        <th className="">Number</th>
                      </tr>
                    </thead>
                  </table>
                  <div>
                    <div className="flex justify-between Statistic  text-light">
                      <h3 className="text-sm font-semibold ">Statistic</h3>
                      <div className="text-sm periods">(last 100 Periods)</div>
                    </div>
                    <div className="flex justify-between items-center text-light">
                      <h3 className="text-sm font-semibold ">
                        Winning Numbers
                      </h3>
                      <div className="text-sm numberspace">
                        {" "}
                        {[...Array(10).keys()].map((num) => (
                          <div
                            key={num}
                            className={`  "text-sm  numberspaceindex `}
                          >
                            {num}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-between items-center text-light">
                      <h3 className="text-sm font-semibold ">Missing</h3>

                      <div className="text-sm numberspace">
                        {statsPages?.missingNumbers?.length > 0 ? (
                          // Array(10).fill(0).map((_, index) => (
                          //     <span key={`default-${index}`} className="">
                          //       0
                          //     </span>
                          //   ))
                          statsPages?.missingNumbers?.map((num) => (
                            <span key={num} className="">
                              {num}
                            </span>
                          ))
                        ) : (
                          <>
                            {Array(10)
                              .fill(0)
                              .map((_, index) => (
                                <span
                                  key={`default-${index}`}
                                  className="text-gray-500"
                                >
                                  0
                                </span>
                              ))}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-between items-center text-light">
                      <h3 className="text-sm font-semibold ">Avg Missing</h3>
                      <div className="text-sm numberspace">
                        {" "}
                        {statsPages?.averageMissing?.map((count, num) => (
                          <span className=" ">{count}</span>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-between items-center text-light">
                      <h3 className="text-sm font-semibold ">Frequency</h3>
                      <div className="text-sm numberspace">
                        {" "}
                        {statsPages?.frequency?.map((freq, num) => (
                          <span className="">{freq}</span>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-between items-center text-light">
                      <h3 className="text-sm font-semibold ">
                        Max Consecutive
                      </h3>
                      <div className="text-sm numberspace">
                        {" "}
                        {statsPages?.maxConsecutive?.map((max, num) => (
                          <span className="  ">{max}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div
                    className="chart_table"
                    ref={chartTableRef}
                    style={{ position: "relative" }}
                  >
                    {results &&
                      results.map((item, index) => (
                        <div
                          className="chart"
                          key={item.periodid}
                          ref={(el) => (activeRefs.current[index] = el)}
                        >
                          <div className="van_chart">
                            <div className="van_num">{item.periodid}</div>
                            <div className="round_num">
                              {[...Array(10).keys()].map((num) => (
                                <span
                                  key={num}
                                  className={`number ${item.number === num ? "active" : ""}`}
                                  style={{
                                    background:
                                      num === item.number
                                        ? item.color === "green violet"
                                          ? "linear-gradient(180deg, #40ad72, #b659fe)"
                                          : item.color === "red violet"
                                            ? "linear-gradient(180deg, #ff0000, #b659fe)"
                                            : item.color
                                        : "transparent",
                                  }}
                                >
                                  {num}
                                </span>
                              ))}
                              {item.number >= 0 && item.number <= 4 && (
                                <div className="number sb">S</div>
                              )}
                              {item.number >= 5 && item.number <= 9 && (
                                <div className="number bs">B</div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                    {/* Draw lines between active numbers */}
                    {lines.length > 1 && (
                      <svg
                        className="line-svg"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          pointerEvents: "none",
                        }}
                      >
                        {lines.map((start, index) => {
                          if (index + 1 < lines.length) {
                            const end = lines[index + 1];
                            return (
                              <line
                                key={index}
                                x1={start.x}
                                y1={start.y}
                                x2={end.x}
                                y2={end.y}
                                stroke="red"
                                strokeWidth="2"
                              />
                            );
                          }
                          return null;
                        })}
                      </svg>
                    )}
                  </div>

                  <div className="pagination-controls mt-4">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={() => paginate(currentPage - 1)}
                            className="page-link"
                            disabled={currentPage === 1}
                          >
                            <RiArrowLeftSLine />
                          </button>
                        </li>
                        <li className="page-item">
                          <span className="page-info">
                            {currentPage} of {totalPages}
                          </span>
                        </li>
                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={() => paginate(currentPage + 1)}
                            className="page-link"
                            disabled={currentPage === totalPages}
                          >
                            <RiArrowRightSLine />
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </TabPanel>

              <TabPanel>
                <div className="myhistory">
                  <Card>
                    {colorList?.length === 0 ? (
                      <p>No data!! Please place the bet</p>
                    ) : (
                      colorList
                        ?.slice(
                          (currentPage - 1) * itemsPerPage,
                          currentPage * itemsPerPage,
                        )
                        .map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className="history_card d-flex justify-content-between cursor-pointer align-items-center"
                              onClick={() =>
                                setShowaccordian(
                                  showaccordian === item ? null : item,
                                )
                              }
                            >
                              <div className="d-flex gap-2">
                                <div
                                  className="icon_profile"
                                  style={{
                                    background:
                                      item.number === 0
                                        ? "linear-gradient(to bottom right, violet, #fd565c)"
                                        : item.number === 5
                                          ? "linear-gradient(to bottom right, #40ad72, violet)"
                                          : item.color,
                                  }}
                                >
                                  {item.big_small &&
                                    !item.number &&
                                    item.big_small}
                                  {item.number && `${item.number}`}
                                  {!item.big_small &&
                                    !item.number &&
                                    item.color &&
                                    `${item.color}`}
                                </div>

                                <div className="text-start">
                                  <h3 className="mb-0 pb-0 colorwhite">
                                    {item.period_id}
                                  </h3>
                                  <p className="mb-0 pb-0 text-sm colorwhite">
                                    {item.datetime}
                                  </p>
                                </div>
                              </div>
                              <div className="status_wingo">
                                <p
                                  className="status"
                                  style={{
                                    backgroundColor:
                                      item.result === "win"
                                        ? "green"
                                        : item.result === "loss"
                                          ? "red"
                                          : item.result === "pending"
                                            ? "orange"
                                            : "inherit",
                                    color:
                                      item.result === "win"
                                        ? "white"
                                        : item.result === "loss"
                                          ? "white"
                                          : item.result === "pending"
                                            ? "white"
                                            : "white",
                                  }}
                                >
                                  {item.result === "win"
                                    ? "Success"
                                    : item.result === "loss"
                                      ? "Failed"
                                      : item.result === "pending"
                                        ? "Waiting"
                                        : ""}
                                </p>
                                <p>
                                  {item.result === "pending"
                                    ? `₹ ${item.amount}`
                                    : ""}
                                </p>

                                <p
                                  style={{
                                    color:
                                      item.result === "win"
                                        ? "green"
                                        : item.result === "loss"
                                          ? "red"
                                          : "inherit",
                                  }}
                                >
                                  {item.result === "win"
                                    ? "+"
                                    : item.result === "loss"
                                      ? "-"
                                      : ""}

                                  {item.result === "win"
                                    ? `₹ ${item?.win_amount?.toFixed(2)}`
                                    : item.result === "loss"
                                      ? item?.amount?.toFixed(2)
                                      : ""}
                                </p>
                              </div>
                            </div>
                            {/* <hr /> */}
                            {showaccordian === item && (
                              <div className="details">
                                <h4 className="text-start">Details</h4>
                                <ul className="p-0">
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Order number
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.orderid}
                                        <FaRegCopy
                                          onClick={() =>
                                            handleCopy(item.orderid)
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                        {copied && (
                                          <span
                                            className="text-success"
                                            style={{ marginLeft: 10 }}
                                          >
                                            Copied!
                                          </span>
                                        )}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Period
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.period_id}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Purchase amount
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        ₹{item.amount}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Quantity
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.quantity}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Amount after tax
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        ₹{item.amount_after_tax}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Tax
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.tax}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Result Number
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.result_number}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Result
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.number}
                                        {item.color === "red" ? (
                                          <span className="text-red-500">
                                            {item.color}
                                          </span>
                                        ) : item.color === "green" ? (
                                          <span className="text-green-500">
                                            {item.color}
                                          </span>
                                        ) : item.color === "violet" ? (
                                          <span className="text-violet-500">
                                            {item.color}
                                          </span>
                                        ) : (
                                          item.color
                                        )}
                                        {item.big_small}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Select
                                      </p>
                                      {/* <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                      {item.big_small && `${item.big_small}`}
                                      {item.number && `${item.number}`}
                                      {item.color && `${item.color}`}
                                    </p> */}
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.big_small && (
                                          <span className="font-weight-bold">
                                            {item.big_small}
                                          </span>
                                        )}
                                        {item.number && (
                                          <span className="text-primary ml-2">
                                            {item.number}
                                          </span>
                                        )}
                                        {!item.big_small &&
                                          !item.number &&
                                          item.color && (
                                            <span
                                              className="ml-2"
                                              style={{ color: item.color }}
                                            >
                                              {item.color}
                                            </span>
                                          )}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Status
                                      </p>
                                      <p
                                        style={{
                                          color:
                                            item.result === "win"
                                              ? "green"
                                              : item.result === "loss"
                                                ? "red"
                                                : item.result === "pending"
                                                  ? "orange"
                                                  : "inherit",
                                        }}
                                        className="d-flex align-items-center gap-1 mb-0 text-sm-custum"
                                      >
                                        {item.result === "win"
                                          ? "Success"
                                          : item.result === "loss"
                                            ? "Failed"
                                            : item.result === "pending"
                                              ? "Waiting"
                                              : ""}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Win/lose
                                      </p>
                                      {/* <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum" style={{ color: item.result === "win" ? "green" : item.result === "loss" ? "red" : "inherit" }}>
                                        {item.result === "win" ? "+" : item.result === "loss" ? "-" : ""}
                                        <span>₹</span>{item.result === "win" ? item.win_amount : item.result === "loss" ? item.amount_after_tax : ""}
                                      </p> */}
                                      <p
                                        className="d-flex align-items-center gap-1 mb-0 text-sm-custum"
                                        style={{
                                          color:
                                            item.result === "win"
                                              ? "green"
                                              : item.result === "loss"
                                                ? "red"
                                                : "inherit",
                                        }}
                                      >
                                        {item.result === "win" && "+"}
                                        {item.result === "loss" && "-"}
                                        <span>₹</span>
                                        {item.result === "win"
                                          ? item?.win_amount.toFixed(2)
                                          : item.result === "loss"
                                            ? item?.amount.toFixed(2)
                                            : ""}
                                      </p>
                                    </div>
                                  </li>
                                  <li className="bg-slate-200 p-1 rounded-md mb-2 wingochargetdiesignresult">
                                    <div className="d-flex justify-content-between gap-2">
                                      <p className="mb-0 text-dark text-sm-custum whitespace-nowrap">
                                        Order time
                                      </p>
                                      <p className="d-flex align-items-center gap-1 mb-0 text-sm-custum text-muted">
                                        {item.datetime}
                                      </p>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </React.Fragment>
                        ))
                    )}
                  </Card>

                  {/* Pagination controls for My History */}
                  <div className="pagination-controls mt-4">
                    <nav>
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            onClick={() => paginate(currentPage - 1)}
                            className="page-link"
                            disabled={currentPage === 1}
                          >
                            <RiArrowLeftSLine />
                          </button>
                        </li>
                        <li className="page-item">
                          <span className="page-info">
                            {currentPage} of{" "}
                            {Math.ceil(colorList.length / itemsPerPage)}
                          </span>
                        </li>
                        <li
                          className={`page-item ${
                            currentPage ===
                            Math.ceil(colorList.length / itemsPerPage)
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <button
                            onClick={() => paginate(currentPage + 1)}
                            className="page-link"
                            disabled={
                              currentPage ===
                              Math.ceil(colorList.length / itemsPerPage)
                            }
                          >
                            <RiArrowRightSLine />
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </Container>
    </section>
  );
}
